import { render, staticRenderFns } from "./goToAnotherAcc.popup-chunk.vue?vue&type=template&id=5ae3d773"
import script from "./goToAnotherAcc.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./goToAnotherAcc.popup-chunk.vue?vue&type=script&lang=ts"
import style0 from "./goToAnotherAcc.popup-chunk.vue?vue&type=style&index=0&id=5ae3d773&prod&lang=scss"
import style1 from "./goToAnotherAcc.popup-chunk.vue?vue&type=style&index=1&id=5ae3d773&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports